import type { PositionsActions } from 'src/store/actions/widgets/positions';
import type { PositionsWidgetViewModel, WidgetTabViewModel } from 'src/store/types';

export const positionsReducer = (
    state: WidgetTabViewModel<PositionsWidgetViewModel>,
    action: PositionsActions,
): WidgetTabViewModel<PositionsWidgetViewModel> => {
    switch (action.type) {
        case 'linkingUpdatePositionsInstrument':
        case 'updatePositionsInstrument': {
            return {
                ...state,
                widget: {
                    ...state.widget,
                    instrument: action.instrument,
                },
            };
        }
        case 'updatePositionsAccount': {
            return { ...state, widget: { ...state.widget, accountIds: [action.accountId] } };
        }

        default:
            return state;
    }
};
